import React from 'react';

const ToggleSwitch = ({ checked, onChange }) => {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      onClick={() => onChange(!checked)}
      className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-300 ease-in-out  ${
        checked ? 'bg-[#7C3BED]' : 'bg-gray-200'
      }`}
    >
      <span
        className={`pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${
          checked ? 'translate-x-5' : 'translate-x-0'
        }`}
      />
    </button>
  );
};

export default ToggleSwitch;

// const ToggleSwitch = ({ checked, onChange, label }) => {
//   return (
//     <label className="flex items-center gap-2 cursor-pointer select-none">
//       <div className="relative active:scale-95 transition-all duration-150">
//         <input
//           type="checkbox"
//           checked={checked}
//           onChange={(e) => onChange(e.target.checked)}
//           className="sr-only peer"
//         />

//         {/* Track */}
//         <div
//           className="
//             w-10 h-5 rounded-full
//             bg-gray-300 peer-checked:bg-purple-600
//             transition-all duration-[450ms]
//             ease-[cubic-bezier(0.25,1,0.30,1)]
//             peer-checked:shadow-[0_0_8px_3px_rgba(124,59,237,0.4)]
//           "
//         ></div>
//         <div
//           className="
//             absolute top-[2px] left-[2px] h-4 w-4 rounded-full 
//             bg-white shadow-md flex items-center justify-center
//             will-change-transform
//             transition-all duration-[450ms]
//             ease-[cubic-bezier(0.25,1,0.30,1)]
//             peer-checked:translate-x-5
//             peer-active:scale-90
//           "
//         >
//           {checked ? (
//             <svg
//               className="w-2.5 h-2.5 text-purple-600"
//               fill="none"
//               stroke="currentColor"
//               viewBox="0 0 24 24"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 strokeWidth="3"
//                 d="M5 13l4 4L19 7"
//               />
//             </svg>
//           ) : (
//             <svg
//               className="w-2.5 h-2.5 text-gray-400"
//               fill="none"
//               stroke="currentColor"
//               viewBox="0 0 24 24"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 strokeWidth="2"
//                 d="M6 18L18 6M6 6l12 12"
//               />
//             </svg>
//           )}
//         </div>
//       </div>

//       {label && <span className="text-sm text-gray-900">{label}</span>}
//     </label>
//   );
// };

// export default ToggleSwitch;